import { parseEntityRef } from '@backstage/catalog-model';

/** Where the plugin's page is mounted. */
export const SCORECARDS_BASE_PATH = '/scorecards';

/** The path segment of the entity page tab that shows the scorecard. */
export const ENTITY_SCORECARD_TAB = 'scorecard';

/**
 * The component page's Scorecard tab for an entity ref, or `undefined` when
 * the ref is malformed (callers then show the name without a link).
 */
export function entityScorecardPath(entityRef: string): string | undefined {
  try {
    const { kind, namespace, name } = parseEntityRef(entityRef, {
      defaultKind: 'component',
      defaultNamespace: 'default',
    });
    const [ns, k, n] = [namespace, kind, name].map(encodeURIComponent);
    return `/catalog/${ns}/${k}/${n}/${ENTITY_SCORECARD_TAB}`;
  } catch {
    return undefined;
  }
}

/** `group:default/platform` -> `platform` (display only). */
export function shortRef(ref: string | null): string {
  return ref ? ref.replace(/^[a-z]+:[^/]+\//i, '') : '—';
}
